// src/models/vendas/Natureza.js
export class Natureza {
    constructor(
        id = 0,
        descricao = '',
        tipoMov = 0,
        movEstoque = true,
        cfopCod = '',
        usaCFOPItens = false,
        infCpl = '',
        infAdFisco = ''        
    ) {
        this.id = id;
        this.descricao = descricao;
        this.tipoMov = tipoMov;
        this.movEstoque = movEstoque;        
        this.cfopCod = cfopCod;
        this.usaCFOPItens = usaCFOPItens;
        this.infCpl = infCpl;
        this.infAdFisco = infAdFisco;        
    }
}
